/**
 * The IRS schema check, left out of the browser.
 *
 * `schema/xsdValidation` reads the IRS XSD files from disk and validates with a native XML
 * library. Neither exists in a browser tab, so the public converter swaps this in (see the
 * `engineBrowserStubs` plugin in vite.config.ts) and the page says plainly that the schema
 * check is not part of what it does. Structure, data and mapping are checked here; the XSD
 * is checked by Tab Service when a file is really filed.
 *
 * The shape matches the real module: a list of problems, empty when there are none.
 */
export function validateIRSXml(_xml: string, _schemaRoot?: string): string[] {
  return [];
}

export const validateXsd = validateIRSXml;

/**
 * The years the real module ships schemas for. The XSD files are not in the browser, but the
 * list of years is a fact about the service, and checkRecords reads it, so it is stated here
 * rather than left empty - an empty list would make every year unfileable.
 */
export const SUPPORTED_SCHEMA_YEARS: number[] = [2025, 2026];
